exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".error-view {\n  text-align: center; }\n  .error-view svg {\n    fill: #bb2525; }\n  .error-view h1 {\n    font-size: 5em; }\n", ""]);

// exports
